import { SimpleFormIterator } from 'react-admin';
import { withStyles } from '@material-ui/core/styles';


const styles = {
  index: {
    display: 'none',
  },
};


export default withStyles(styles)(SimpleFormIterator);



// WEBPACK FOOTER //
// ./src/components/NoVisibleIndexSimpleFormIterator.js